import React from "react";
import { Modal, SemanticShorthandItem, ModalContentProps, ModalHeaderProps } from "semantic-ui-react";

interface IProps {
    open?: boolean;
    trigger?: React.ReactNode;
    header: SemanticShorthandItem<ModalHeaderProps>;
    content: SemanticShorthandItem<ModalContentProps>;
    onSuccess: VoidFunction | JSX.Element;
    onCancel?: VoidFunction | JSX.Element;
}

const ModalYesNo: React.FC<IProps> = ({ open, trigger, header, content, onSuccess, onCancel }) => {

    return (
        <>
            <Modal
                size="tiny"
                open={open}
                trigger={trigger}
                header={header}
                content={content}
                actions={[
                    (typeof onCancel === "function")
                        ? { key: "não", content: "Não", onClick: onCancel }
                        : onCancel ?? { key: "não", content: "Não" },
                    (typeof onSuccess === "function")
                        ? { key: "sim", content: "Sim", color: "pink", onClick: onSuccess }
                        : onSuccess
                ]}
            >
            </Modal>
        </>
    );
}

export default ModalYesNo;
